import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import downArrowSmall from "svg/downArrowSmall.svg";
import upArrowSmall from "svg/upArrowSmall.svg";
import downArrowLarge from "svg/downArrowLarge.svg";
import upArrowLarge from "svg/upArrowLarge.svg";
import "./style.scss";

const MobileSort = ({
  label,
  handleSelectInput,
  value,
  options = [],
  defaultValue = "",
  type = "__drop-down",
  inputRef,
  sorting,
  onSorting,
}) => {
  const [displayOptions, setDisplayOptions] = useState(false);
  let dropdownOptions = [...options];

  const { dataKey, order } = sorting;

  const onSortingChange = (field) => {
    onSorting(field);
  };

  useEffect(() => {
    let closeDropDownHandler = (event) => {
      if (
        inputRef &&
        inputRef.current &&
        inputRef.current != null &&
        event &&
        event.target &&
        event.target != null &&
        !inputRef.current.contains(event.target)
      ) {
        setDisplayOptions(false);
      }
    };
    document.addEventListener("mousedown", closeDropDownHandler);
    return () => {
      document.removeEventListener("mouse", closeDropDownHandler);
    };
  });

  const handleDisplayOptions = () => {
    setDisplayOptions((current) => !current);
  };
  const handleClick = (e, option) => {
    setDisplayOptions((current) => !current);
    handleSelectInput(e, option);
  };
  const getOptions = () => {
    return (
      dropdownOptions &&
      dropdownOptions.map((option, index) => {
        return (
          <div className="select__dropdown__list--option" key={index} onClick={(e) => handleClick(e, option)}>
            {option.keyName}
          </div>
        );
      })
    );
  };

  const dropdownValue = value && value.keyName != null && value.keyName !== "" ? value.keyName : defaultValue;
  const selectedSortValue = value && value.valueName != null && value.valueName !== "" ? value.valueName : "";
  const fieldClassName = "select__dropdown__field" + type;
  const inputClassName = fieldClassName + "__input";
  const inputClassNameText = dropdownValue === defaultValue ? "" : inputClassName + "--sort";
  const inputClassNameIcon = fieldClassName + "--icon";
  const downArrowIcon = type === "__pagination" ? downArrowSmall : downArrowLarge;
  const upArrowIcon = type === "__pagination" ? upArrowSmall : upArrowLarge;

  return (
    <div className="form-group select-wrapper">
      {label !== "" && label != null && (
        <div className="select__label">
          <span className="select__label--text">{label}</span>
        </div>
      )}
      <div id="custom-dropdown" ref={inputRef} className="select__dropdown">
        <div className={`${fieldClassName}`}>
          <Button className={`form-control ${inputClassName}`}>
            <span className={`${inputClassNameText}`} onClick={() => onSortingChange(selectedSortValue)}>
              {dropdownValue}&nbsp;
              {dataKey ? <img src={`${order === "asc" ? upArrowSmall : downArrowSmall}`} /> : null}
            </span>
          </Button>
          <img
            src={displayOptions ? upArrowIcon : downArrowIcon}
            alt={"dropdown-icon"}
            className={inputClassNameIcon}
            onClick={handleDisplayOptions}
          />
        </div>
        {displayOptions && <div className="select__dropdown__list">{getOptions()}</div>}
      </div>
    </div>
  );
};

export default MobileSort;
